import React from "react";
import { Rail } from "web/react/components/rail/rail";
import { RailCardSerializer } from "web/types/serializers";
import { RelatedRailCard } from "./related-rail-card";

interface RelatedRailProps {
    title?: string;
    candidates: RailCardSerializer[];
    isFeedRedesign?: boolean;
    analyticsLabel: string;
    shouldWrap?: boolean;
    logoSize?: "xl" | "xxl";
}

export function RelatedRail({
    title,
    candidates,
    analyticsLabel,
    shouldWrap = false,
    logoSize = "xl",
}: RelatedRailProps): React.ReactElement {
    return (
        <Rail title={title} wrapLimit={6} analyticsLabel={analyticsLabel} shouldWrap={shouldWrap}>
            {candidates.map((candidate) => (
                <RelatedRailCard key={candidate.url} candidate={candidate} logoSize={logoSize} />
            ))}
        </Rail>
    );
}
